<template>
  <div style="position: relative;">
    <el-form ref="QueryLevelTitleFilter" :model="QueryLevelTitle" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="薪级名称" prop="formFilter.jobLevelName">
          <el-input class="filter-item" v-model="QueryLevelTitle.formFilter.jobLevelName"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="所属序列" prop="formFilter.gcode">
          <el-select class="filter-item" v-model="QueryLevelTitle.formFilter.gcode" :clearable="true" filterable
                     placeholder="所属序列" :loading="QueryLevelTitle.gcode.impl.loading"
                     @visible-change="QueryLevelTitle.gcode.impl.onVisibleChange"
                     @change="onGcodeValueChange">
            <el-option v-for="item in QueryLevelTitle.gcode.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="薪资范围" prop="formFilter.jobSalary">
          <input-number-range class="filter-item"
                              v-model="QueryLevelTitle.formFilter.jobSalary" :clearable="true"
                              startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>
        <el-form-item label="所属部门" prop="formFilter.sysDeptId">
          <el-cascader class="filter-item" v-model="QueryLevelTitle.formFilter.sysDeptId" :clearable="true" filterable
                       placeholder="所属部门" :loading="QueryLevelTitle.sysDeptId.impl.loading" :props="{value: 'deptId', label: 'deptName', checkStrictly: true}"
                       @visible-change="QueryLevelTitle.sysDeptId.impl.onVisibleChange" :options="QueryLevelTitle.sysDeptId.impl.dropdownList"
                       @change="onSysDeptIdValueChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="登录账号" prop="formFilter.loginName">
          <el-input class="filter-item" v-model="QueryLevelTitle.formFilter.loginName"
                    :clearable="true" placeholder="登录账号"
          />
        </el-form-item>
        <el-form-item label="员工姓名" prop="formFilter.showName">
          <el-input class="filter-item" v-model="QueryLevelTitle.formFilter.showName"
                    :clearable="true" placeholder="员工姓名"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetQueryLevelTitle">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshQueryLevelTitle(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="QueryLevelTitle" :model="formData" class="full-width-input" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>薪级列表</span>
              <div class="base-card-operation">
                <!--
                <el-button @click="onExportClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('JobLevelManage:QueryLevelTitle:export')">
                  导出
                </el-button>
                -->
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paJobLevel" :data="QueryLevelTitle.PaJobLevel.impl.dataList" :size="defaultFormItemSize" @sort-change="QueryLevelTitle.PaJobLevel.impl.onSortChange"
                          header-cell-class-name="table-header-gray"
                          highlight-current-row @current-change="QueryLevelTitle.PaJobLevel.impl.currentRowChange"
                          @row-click="handleRowClick" row-key="id" default-expand-all height="550px"
                >
                  <el-table-column type="selection" width="55px"></el-table-column>
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="QueryLevelTitle.PaJobLevel.impl.getTableIndex" />
                  <el-table-column label="名称" prop="name" width="180px">
                  </el-table-column>
                  <el-table-column label="所属序列" prop="gcodeDictMap.name">
                  </el-table-column>
                  <el-table-column label="薪级编码" prop="code">
                  </el-table-column>
                  <el-table-column label="所属部门" prop="deptIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="岗位工资" prop="jobSalary">
                  </el-table-column>
                  <el-table-column label="描述" prop="detail">
                  </el-table-column>
                  <el-table-column label="备注" prop="remark">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right" width="120px">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('JobLevelManage:QueryLevelTitle:delete')">
                        删除
                      </el-button>
                      <el-button @click.stop="onEditJobLevelClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('JobLevelManage:QueryLevelTitle:EditJobLevel')">
                        编辑
                      </el-button>
                      <el-button @click="onAddJobLevelClick(scope.row)" type="text" :size="defaultFormItemSize" v-show="scope.row.type==='group'&&scope.row.id!==0"
                                 :disabled="!checkPermCodeExist('JobLevelManage:QueryLevelTitle:AddJobLevel') || !addJobLevelEnabled">
                        添加
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="12" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>员工列表</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="sysUser" :data="QueryLevelTitle.SysUser.impl.dataList" :size="defaultFormItemSize" @sort-change="QueryLevelTitle.SysUser.impl.onSortChange"
                          header-cell-class-name="table-header-gray" height="550px"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="QueryLevelTitle.SysUser.impl.getTableIndex" />
                  <el-table-column label="登录账号" prop="loginName">
                  </el-table-column>
                  <el-table-column label="姓名" prop="showName">
                  </el-table-column>
                  <el-table-column label="所属部门" prop="deptIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="职位状态" prop="jobStatusDictMap.name">
                  </el-table-column>
                  <el-table-column label="工龄" prop="workYears">
                  </el-table-column>
                  <el-table-column label="薪级" prop="jobLevelIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="职称" prop="jobTitleIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="性别" prop="genderDictMap.name">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click.stop="onEditUserInfoClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('JobLevelManage:QueryLevelTitle:EditUserInfo')">
                        编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaJobLevelController, SysUserController, DictionaryController, SysDeptController} from '@/api';
import addJobLevel from '@/views/JobLevel/addJobLevel.vue';
import editJobLevel from '@/views/JobLevel/editJobLevel.vue';

export default {
  name: 'JobLevelManage',
  props: {
    name: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        PaJobLevel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          deptId: undefined,
          deptTid: undefined,
          detail: undefined,
          jobSalary: undefined,
          remark: undefined,
          sort: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        },
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      },
      QueryLevelTitle: {
        formFilter: {
          jobLevelName: undefined,
          gcode: undefined,
          jobSalary: [],
          sysDeptId: undefined,
          loginName: undefined,
          showName: undefined
        },
        formFilterCopy: {
          jobLevelName: undefined,
          gcode: undefined,
          jobSalary: [],
          sysDeptId: undefined,
          loginName: undefined,
          showName: undefined
        },
        PaJobLevel: {
          impl: new TableWidget(this.loadPaJobLevelWidgetData, this.loadPaJobLevelVerify, false, true, 'sort', 1)
        },
        SysUser: {
          impl: new TableWidget(this.loadSysUserWidgetData, this.loadSysUserVerify, false, false, 'showName', 1)
        },
        gcode: {
          impl: new DropdownWidget(this.loadGcodeDropdownList)
        },
        sysDeptId: {
          impl: new DropdownWidget(this.loadSysDeptIdDropdownList, true, 'deptId')
        },
        JobLevelDiv: {
          isInit: false
        },
        UserInfoDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.paJobLevel.clearSelection();
      }
      this.$refs.paJobLevel.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetQueryLevelTitle () {
      this.$refs.QueryLevelTitleFilter.resetFields();
      this.refreshQueryLevelTitle(true);
    },
    /**
     * 薪级列表数据获取函数，返回Promise
     */
    loadPaJobLevelWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paJobLevelDtoFilter: {
          gcode: this.QueryLevelTitle.formFilterCopy.gcode,
          name: this.QueryLevelTitle.formFilterCopy.jobLevelName,
          deptTid: this.QueryLevelTitle.formFilterCopy.sysDeptId,
          jobSalaryStart: Array.isArray(this.QueryLevelTitle.formFilterCopy.jobSalary) ? this.QueryLevelTitle.formFilterCopy.jobSalary[0] : undefined,
          jobSalaryEnd: Array.isArray(this.QueryLevelTitle.formFilterCopy.jobSalary) ? this.QueryLevelTitle.formFilterCopy.jobSalary[1] : undefined,
          searchString: this.name
        },
        sysUserDtoFilter: {
          deptTid: this.QueryLevelTitle.formFilterCopy.sysDeptId
        }
      }
      return new Promise((resolve, reject) => {
        PaJobLevelController.list(this, params).then(res => {
          let dataList = res.data.dataList;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].type !== 'level') {
              dataList[i].gcodeDictMap.name = '';
              dataList[i].jobSalary = undefined;
              dataList[i].code = '';
            }
          }
          resolve({
            dataList: treeDataTranslate(dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.QueryLevelTitle.PaJobLevel.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.QueryLevelTitle.PaJobLevel.impl.currentRow.id, 'id');
              this.$refs.paJobLevel.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 薪级列表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaJobLevelVerify () {
      this.QueryLevelTitle.formFilterCopy.gcode = this.QueryLevelTitle.formFilter.gcode;
      this.QueryLevelTitle.formFilterCopy.sysDeptId = this.QueryLevelTitle.formFilter.sysDeptId;
      this.QueryLevelTitle.formFilterCopy.jobLevelName = this.QueryLevelTitle.formFilter.jobLevelName;
      this.QueryLevelTitle.formFilterCopy.sysDeptId = this.QueryLevelTitle.formFilter.sysDeptId;
      this.QueryLevelTitle.formFilterCopy.jobSalary = this.QueryLevelTitle.formFilter.jobSalary;
      return true;
    },
    /**
     * 员工列表数据获取函数，返回Promise
     */
    loadSysUserWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysUserDtoFilter: {
          loginName: this.QueryLevelTitle.formFilterCopy.loginName,
          deptTid: this.QueryLevelTitle.formFilterCopy.sysDeptId,
          showName: this.QueryLevelTitle.formFilterCopy.loginName,
          userStatus: this.QueryLevelTitle.formFilterCopy.showName,
          jobLevelId: (this.QueryLevelTitle.PaJobLevel.impl.currentRow || {}).id
        }
      }
      return new Promise((resolve, reject) => {
        SysUserController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 员工列表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysUserVerify () {
      this.QueryLevelTitle.formFilterCopy.loginName = this.QueryLevelTitle.formFilter.loginName;
      this.QueryLevelTitle.formFilterCopy.sysDeptId = this.QueryLevelTitle.formFilter.sysDeptId;
      this.QueryLevelTitle.formFilterCopy.loginName = this.QueryLevelTitle.formFilter.loginName;
      this.QueryLevelTitle.formFilterCopy.showName = this.QueryLevelTitle.formFilter.showName;
      return true;
    },
    /**
     * 所属序列下拉数据获取函数
     */
    loadGcodeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_job_level_group'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属序列选中值改变
     */
    onGcodeValueChange (value) {
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadSysDeptIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        SysDeptController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属部门选中值改变
     */
    onSysDeptIdValueChange (value) {
    },
    /**
     * 更新薪级列表
     */
    refreshJobLevelDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.QueryLevelTitle.PaJobLevel.impl.refreshTable(true, 1);
      } else {
        this.QueryLevelTitle.PaJobLevel.impl.refreshTable();
      }
      this.QueryLevelTitle.JobLevelDiv.isInit = true;
    },
    /**
     * 更新员工列表
     */
    refreshUserInfoDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.QueryLevelTitle.SysUser.impl.refreshTable(true, 1);
      } else {
        this.QueryLevelTitle.SysUser.impl.refreshTable();
      }
      this.QueryLevelTitle.UserInfoDiv.isInit = true;
    },
    /**
     * 更新薪级管理
     */
    refreshQueryLevelTitle (reloadData = false) {
      if (reloadData) {
        this.QueryLevelTitle.PaJobLevel.impl.refreshTable(true, 1);
      } else {
        this.QueryLevelTitle.PaJobLevel.impl.refreshTable();
      }
      if (reloadData) {
        this.QueryLevelTitle.SysUser.impl.refreshTable(true, 1);
      } else {
        this.QueryLevelTitle.SysUser.impl.refreshTable();
      }
      if (!this.QueryLevelTitle.isInit) {
        // 初始化下拉数据
      }
      this.QueryLevelTitle.isInit = true;
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      if (row.pid === -1) {
        this.$message.error('删除失败!节点不能删除!');
        return;
      }
      if (row.children !== undefined && row.children.length > 0) {
        this.$message.error('删除失败!请先删除子项!');
        return;
      }

      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaJobLevelController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.QueryLevelTitle.PaJobLevel.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditJobLevelClick (row) {
      let params = {
        id: row.id
      };

      this.$dialog.show('编辑', editJobLevel, {
        area: '400px'
      }, params).then(res => {
        this.QueryLevelTitle.PaJobLevel.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        paJobLevelDtoFilter: {
          gcode: this.QueryLevelTitle.formFilterCopy.gcode,
          name: this.QueryLevelTitle.formFilterCopy.jobLevelName,
          deptTid: this.QueryLevelTitle.formFilterCopy.sysDeptId,
          jobSalaryStart: Array.isArray(this.QueryLevelTitle.formFilterCopy.jobSalary) ? this.QueryLevelTitle.formFilterCopy.jobSalary[0] : undefined,
          jobSalaryEnd: Array.isArray(this.QueryLevelTitle.formFilterCopy.jobSalary) ? this.QueryLevelTitle.formFilterCopy.jobSalary[1] : undefined,
          searchString: this.name
        },
        sysUserDtoFilter: {
          deptTid: this.QueryLevelTitle.formFilterCopy.sysDeptId
        }
      };

      PaJobLevelController.export(this, params, '薪级列表.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    /**
     * 添加
     */
    onAddJobLevelClick (row) {
      row = (row || this.QueryLevelTitle.PaJobLevel.impl.currentRow || {});
      if (row.type !== 'group') {
        this.$message.error('添加失败!不能添加子节点!');
        return;
      }
      let type = (row.pid === -1) ? 'group' : 'level';
      let params = {
        pid: row.id,
        type: type
      };
      let title = '添加';
      if (params.type === 'group') {
        title = '添加组';
      }

      this.$dialog.show(title, addJobLevel, {
        area: '400px'
      }, params).then(res => {
        this.refreshJobLevelDivWidget();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditUserInfoClick (row) {
      let params = {
        userId: row.userId
      };

      params.closeVisible = 1;
      this.$router.push({name: 'EditUserInfo', query: params});
    },
    onResume () {
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaJobLevel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          deptId: undefined,
          deptTid: undefined,
          detail: undefined,
          jobSalary: undefined,
          remark: undefined,
          sort: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        },
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshQueryLevelTitle();
    }
  },
  computed: {
    addJobLevelEnabled () {
      return this.QueryLevelTitle.PaJobLevel.impl.currentRow != null;
    },
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.formInit();
  },
  watch: {
    // 薪级列表选择行数据变化
    'QueryLevelTitle.PaJobLevel.impl.currentRow': {
      handler (newValue) {
        this.QueryLevelTitle.SysUser.impl.refreshTable(true, 1);
      },
      immediate: true
    }
  }
}
</script>
